import React, {Suspense, lazy} from 'react';
import {Navigate, useRoutes, useLocation} from 'react-router-dom';
//  layouts
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
//  components
import LoadingScreen from '../components/LoadingScreen';
import {PATH_AFTER_LOGIN} from "../config";
import DiscountCodeCreate from "../pages/managements/discount-code/DiscountCodeCreate";
import useAuth from '../hooks/useAuth';
import TaxOfficeReport from 'src/pages/managements/taxes/TaxOfficeReport';
import ClosureShops from 'src/pages/managements/closure-shops/ClosureShops';
import Reports from 'src/pages/managements/reports/Reports';
import CharityDonations from 'src/pages/managements/reports/CharityDonations';

const Loadable = (Component) => (props) => {
    //  eslint-disable-next-line react-hooks/rules-of-hooks
    const {pathname} = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')}/>}>
            <Component {...props} />
        </Suspense>
    );
};

export default function Router() {
    const { shopPermissions } = useAuth()


    return useRoutes([
        {
            path: 'auth',
            children: [
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <Login/>
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: 'dashboard',
            children: [
                {
                    path: '',
                    element: (
                        <AuthGuard>
                            <DashboardLayout/>
                        </AuthGuard>
                    ),
                    children: [
                        {path: '', element: <Dashboard/>},
                    ],
                },
            ],
        },
                         {
            path: 'user',
            children: [
                {
                    path: '',
                    element: (
                        <AuthGuard>
                            <DashboardLayout/>
                        </AuthGuard>
                    ),
                    children: [
                        {element: <Navigate to="/user/account"/>, index: true},
                        {
                            path: 'account', element: <UserAccount/>,
                        },
                    ],
                },
            ],
        },
         {
             path: 'management',
             children: [
                 {
                     path: '',
                     element: (
                         <AuthGuard>
                             <DashboardLayout/>
                         </AuthGuard>
                     ),
                     children: [
                         {element: <Navigate to="/management/shop-all"/>, index: true},
                         {path: 'shop-all', element: <Shops/>},
                         {path: 'shop/create', element: <NewShop/>},
                         {path: 'shop/edit/:rootShopId', element: <EditShop/>},
                         {path: 'shop-category', element: <ShopCategory/>},
                         {path: 'shop-category-highlight', element: <CategouryHighlight/>},
                         {path: 'shop-meal_tags', element: <MealTags/>},
                         {path: 'geofance', element: <Geofance/>},
                        {path: 'closure-shops', element: <ClosureShops/>},
                         // {path: 'shop/:shopId/comment', element: <ShopComment/>},
                         {
                             path: 'discountCode',
                             children: [
                                 {path: '', element: <DiscountCode/>},
                                 {path: 'create', element: <DiscountCodeCreate/>},
                                 {path: 'edit/:discountCodeId', element: <DiscountCodeEdit/>},
                             ],
                         },

                         {
                            path: 'discountCode/:rootShopId/create', element: <DiscountCodeCreateShop/>
                        },
                         {
                             path: 'qazvin-pro-plan',
                             children: [
                                 {path: '', element: <QazvinProPlan/>},
                                 {path: 'create', element: <QazvinProPlanCreate/>},
                                 {path: 'edit/:planUuid', element: <QazvinProPlanEdit/>},
                             ],
                         },
                         {
                             path: 'qazvin-pro-benefit-pool',
                             children: [
                                 {path: '', element: <QazvinProBenefitPool/>},
                                 {path: 'create', element: <QazvinProBenefitPoolCreate/>},
                                 {path: 'edit/:poolId', element: <QazvinProBenefitPoolEdit/>},
                                 {path: ':poolId/codes', element: <QazvinProBenefitPoolCodes/>},
                                 {path: ':poolId/claims', element: <QazvinProBenefitPoolClaims/>},
                             ],
                         },
                         {
                             path: 'advertisement',
                             children: [
                                 {path: '', element: <Advertisement/>},
                                 {path: 'create', element: <AdvertisementCreate/>},
                                 {path: 'edit/:advertisementId', element: <AdvertisementEdit/>},
                             ],
                         },
                         {
                             path: 'product-category',
                             children: [
                                 {path: '', element: <ProductCate/>},

                             ],
                         },

                         {
                             path: 'user',
                             children: [
                                 {path: '', element: <UserManagement/>},
                             ],
                         },
                         {
                             path: 'invoice',
                             children: [
                                 {path: '', element: <InvoiceManagement/>},
                             ],
                         },
                         {
                             path: 'delay-invoice',
                             children: [
                                 {path: '', element: <TabsInvoice/>},
                             ],
                         },
                         {
                             path: 'setting',
                             children: [
                                 {path: '', element: <SettingsTabs/>},
                             ],
                         },

                         {
                             path: 'cashback-segments',
                             children: [
                                 {path: '', element: <CashbackSegments/>},
                             ],
                         },

                         {
                             path: 'shop-product-category',
                             children: [
                                 {path: 'create/:rootShopId', element: <ShopProductCategory/>},
                                 {path: ':rootShopId/edit/:shopProductCategoryId', element: <TabsProductCategory/>},

                             ],
                         },

                         {
                            path: 'shop/:rootShopId/product/:productId/stock', element: <ShopGeneralProductStock/>,
                        },

                         {
                             path: 'product',
                             children: [
                                 {path: 'create/:rootShopId', element: <CreateProduct/>},
                                 {path: ':rootShopId/edit/:productId', element: <TabsProduct/>},

                             ],
                         },
                         {
                             path: 'role',
                             children: [
                                 {path: '', element: <Role/>},

                             ],
                         },
                         {
                             path: 'settlement',
                             children: [
                                 {path: '', element: <Settlement/>},
                                 {path: 'details/:detailsId', element: <SettlementDetails/>}
                             ],
                         },
                         {
                            path: 'settlement-accumulative',
                            children: [
                                {path: '', element: <SettlementAccumulative/>},
                                {path: ':detailsId/details', element: <DetailsSettlementAccumulative/>}
                            ],
                        },
                         {
                             path: 'transaction',
                             children: [
                                 {path: '', element: <TransactionManagement/>},

                             ],
                         },
                         {
                            path: 'wallet-payment',
                            children: [
                                {path: '', element: <WalletPayment/>},

                            ],
                        },
                         {
                             path: 'priceChange',
                             children: [
                                 {path: '', element: <PriceChangeManagement/>},
                             ],
                         },
                         {
                             path: 'comment',
                             children: [
                                 {path: '', element: <Comment/>},

                             ],
                         },
                         {
                            path: 'activity',
                            children: [
                                {path: '', element: <Activity/>},
                                {path: ':activityId', element: <ActivityDetails/>},

                            ],
                        },
                        {
                            path: 'credit',
                            children: [
                                {path: '', element: <CreditService/>},
                                // {path: ':activityId', element: <ActivityDetails/>},

                            ],
                        },
                            {
                            path: 'taxes',
                            children: [
                                {path: '', element: <TaxOfficeReport/>},
                                // {path: ':activityId', element: <ActivityDetails/>},

                            ],
                        },
                         {
                             path: 'courier',
                             children: [
                                 {path: '', element: <CourierManagement/>},
                                 {path: 'edit/:courierId', element: <EditCourier/>},
                                 {path: 'create', element: <CreateCourier/>},
                             ],
                         },
                          {
                             path: 'reports',
                             children: [
                                 {path: '', element: <Reports/>},
                                 {path: 'charity-donations', element: <CharityDonations/>},
                             ],
                         },
                               {
                             path: 'messenger',
                             children: [
                                 {path: '', element: <Messenger/>},
                             ],
                         },
                     ],
                 },
             ],
         },
        //  Dashboard Routes
        //  Main Routes
        // {
        //     path: '*',
        //     element: <LogoOnlyLayout/>,
        //     children: [
        //         {path: '*', element: <Navigate to={PATH_AFTER_LOGIN} replace/>},
        //     ],
        // },
        // {
        //     path: '/',
        //     element: <Navigate to={PATH_AFTER_LOGIN} replace/>,
        // },
        // {path: '*', element: <Navigate to={PATH_AFTER_LOGIN} replace/>},
        {path: '*', element: <Navigate to={PATH_AFTER_LOGIN} replace/>},
  


    ]);
}

//  auth
const Login = Loadable(lazy(() => import('../pages/auth/Login')));

//  Dashboard
const Dashboard = Loadable(lazy(() => import('../pages/Dashboard')));
const UserAccount = Loadable(lazy(() => import('../pages/user/Account')));
const Shops = Loadable(lazy(() => import('../pages/managements/shops/Shops')));
const ShopCategory = Loadable(lazy(() => import('../pages/managements/shops/Categouries')));
const Geofance = Loadable(lazy(() => import('../pages/managements/geofance/Geofance')));
const MealTags = Loadable(lazy(() => import('../pages/managements/shops/MealTags')));
const NewShop = Loadable(lazy(() => import('../pages/managements/shops/CreateShop')));
const EditShop = Loadable(lazy(() => import('../pages/managements/shops/EditShop')));
const CategouryHighlight = Loadable(lazy(() => import('../pages/managements/shops/CategouryHighlight')));

//  DiscountCodeManagement
const DiscountCode = Loadable(lazy(() => import('../pages/managements/discount-code/DiscountCode')));
const Discountreate = Loadable(lazy(() => import('../pages/managements/discount-code/DiscountCodeCreate')));
const DiscountCodeEdit = Loadable(lazy(() => import('../pages/managements/discount-code/DiscountCodeEdit')));

// QazvinProPlanManagement
const QazvinProPlan = Loadable(lazy(() => import('../pages/managements/qazvin-pro-plan/QazvinProPlan')));
const QazvinProPlanCreate = Loadable(lazy(() => import('../pages/managements/qazvin-pro-plan/QazvinProPlanCreate')));
const QazvinProPlanEdit = Loadable(lazy(() => import('../pages/managements/qazvin-pro-plan/QazvinProPlanEdit')));

// QazvinProBenefitPoolManagement
const QazvinProBenefitPool = Loadable(lazy(() => import('../pages/managements/qazvin-pro-benefit-pool/QazvinProBenefitPool')));
const QazvinProBenefitPoolCreate = Loadable(lazy(() => import('../pages/managements/qazvin-pro-benefit-pool/QazvinProBenefitPoolCreate')));
const QazvinProBenefitPoolEdit = Loadable(lazy(() => import('../pages/managements/qazvin-pro-benefit-pool/QazvinProBenefitPoolEdit')));
const QazvinProBenefitPoolCodes = Loadable(lazy(() => import('../pages/managements/qazvin-pro-benefit-pool/QazvinProBenefitPoolCodes')));
const QazvinProBenefitPoolClaims = Loadable(lazy(() => import('../pages/managements/qazvin-pro-benefit-pool/QazvinProBenefitPoolClaims')));

// Advertisement
const Advertisement = Loadable(lazy(() => import('../pages/managements/advertisement/Advertisement')));
const AdvertisementCreate = Loadable(lazy(() => import('../pages/managements/advertisement/AdvertisementCreate')));
const AdvertisementEdit = Loadable(lazy(() => import('../pages/managements/advertisement/AdvertisementEdit')));

// UserMaCodeCnagement
const UserManagement = Loadable(lazy(() => import('../pages/managements/user/UserManagement')));
// PriceChangeManagement
const InvoiceManagement = Loadable(lazy(() => import('../pages/managements/invoice/Invoice')));
// DelayInvoice
const TabsInvoice = Loadable(lazy(() => import('../pages/managements/tabs-invoice/TabsInvoice')));

// productCategory
const ProductCate = Loadable(lazy(() => import('../pages/managements/product-category/ProductCate')));

// Settings
const SettingsTabs = Loadable(lazy(() => import('../pages/managements/settings/SettingsTabs')));
const CashbackSegments = Loadable(lazy(() => import('../pages/managements/settings/CashbackSegments')));

// shopProductCategory

const ShopProductCategory = Loadable(lazy(() => import("../pages/managements/shop-product-category/ShopProductCategory")));
const TabsProductCategory = Loadable(lazy(() => import("../pages/managements/shop-product-category/tabs-productCategory/TabsProductCategory")));

// role
const Role = Loadable(lazy(() => import('../pages/managements/role/RoleManagement')));

// settlement
const Settlement = Loadable(lazy(() => import('../pages/managements/settlement/Settlement')));
const SettlementDetails = Loadable(lazy(() => import('../pages/managements/settlement/DetailsSettlement')));

// settlement-accumulative
const SettlementAccumulative = Loadable(lazy(() => import('../pages/managements/settlement-accumulative/SettlementAccumulative')));
const DetailsSettlementAccumulative = Loadable(lazy(() => import('../pages/managements/settlement-accumulative/DetailsSettlementAccumulative')));

// transaction
const TransactionManagement = Loadable(lazy(() => import('../pages/managements/transaction/TransactionManagement')));

// priceChange
const PriceChangeManagement = Loadable(lazy(() => import('../pages/managements/priceChange/PriceChangeManagement')));

// courier
const CourierManagement = Loadable(lazy(() => import('../pages/managements/courier/CourierManagement')));
const EditCourier = Loadable(lazy(() => import('../pages/managements/courier/EditCourier')));
const CreateCourier = Loadable(lazy(() => import('../pages/managements/courier/CreateCourier')));

// product
const CreateProduct = Loadable(lazy(() => import('../pages/managements/product/CreateProduct')));
const EditProduct = Loadable(lazy(() => import('../pages/managements/product/EditProduct')));
const TabsProduct = Loadable(lazy(() => import('../pages/managements/product/tabs-product/TabsProduct')));

// comment
const Comment = Loadable(lazy(() => import('../pages/managements/comments/Comment')));

//wallet-payment
const WalletPayment = Loadable(lazy(() => import('../pages/managements/wallet-payment/WalletPayment')));

//productStock
const ShopGeneralProductStock = Loadable(lazy(() => import('../sections/@dashboard/shop/shop-tabs/ShopGeneralProductStock')));

//discount-code-shop
const DiscountCodeCreateShop = Loadable(lazy(() => import('../pages/managements/shops/discount-code/DiscountCodeCreate')));

//activity

const Activity = Loadable(lazy(() => import('../pages/managements/activity/Activity')));

const ActivityDetails = Loadable(lazy(() => import('../pages/managements/activity/ActivityDetails')));

//credit
const CreditService = Loadable(lazy(() => import('../pages/managements/credit/CreditService')));

//messenger 

const Messenger = Loadable(lazy(() => import('../pages/managements/messenger/Messenger')));
